





















































































import Component, { mixins } from "vue-class-component";
import TextDayChangePicker from "../components/common/TextDayChangePicker.vue";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import BaseTable from "../components/common/BaseTable.vue";
import AxiosMixin from "../mixins/axiosMixin";
import {
  HeaderWidthItem,
  SearchCondition,
  ObjectId,
  dateJp,
  getStorageBoolean,
  getStorageNumber
} from "@/types";
import { Watch, Ref } from "vue-property-decorator";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import LoadingDialog from "../components/common/LoadingDialog.vue";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextDayChangePicker,
    TextMonthChangePicker,
    BaseTable,
    LoadingDialog
  }
})
export default class CareUserInvoice extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;

  private onlyInvoicer = true; //請求あり利用者だけを表示
  private printType = 0; //請求書種類
  private printSum = true; //合計・小計を印刷する
  private printDeducation = true; //医療費控除対象枠を印刷する
  private printNoInvoice = true; //請求なし対象者も印刷する
  private invoiceYMD: string = dateJp(new Date()).substr(0, 10); //請求書日付
  private receiptYMD: string = dateJp(new Date()).substr(0, 10); //領収書日付

  //対象年月
  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  private headerItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "is_printed",
      text: "利用者請求確定済",
      width: "96px"
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px"
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px"
    },
    {
      value: "name",
      text: "氏名",
      width: "140px"
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px"
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px"
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "190px"
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px"
    }
  ];

  private tableItems: object[] = [];

  mounted() {
    const searchCondition: SearchCondition = {
      isDone: true,
      insuranceNo: "",
      insuranceName: "",
      userCode: "",
      userKana: "",
      userInsNo: ""
    };
    if (this.$route.query.only) {
      if (this.$route.query.only == "false") {
        searchCondition.isDone = false;
      }
    }
    if (typeof this.$route.query.insurance_no === "string") {
      searchCondition.insuranceNo = this.$route.query.insurance_no;
    }
    if (typeof this.$route.query.insurance_name === "string") {
      searchCondition.insuranceName = this.$route.query.insurance_name;
    }
    if (typeof this.$route.query.ibow_id === "string") {
      searchCondition.userCode = this.$route.query.ibow_id;
    }
    if (typeof this.$route.query.furigana === "string") {
      searchCondition.userKana = this.$route.query.furigana;
    }
    if (typeof this.$route.query.insured_no === "string") {
      searchCondition.userInsNo = this.$route.query.insured_no;
    }
    this.baseTable.setSearchCondition(searchCondition);

    this.onlyInvoicer = getStorageBoolean("onlyInvoicer", false);
    this.printType = getStorageNumber("printType");
    this.printSum = getStorageBoolean("printSum", true);
    this.printDeducation = getStorageBoolean("printDeducation", true);

    this.updateData(this.baseTable.getSearchCondition());
  }

  @Watch("onlyInvoicer")
  onlyInvoicerChanged() {
    localStorage.setItem("onlyInvoicer", String(this.onlyInvoicer));
  }

  @Watch("printType")
  printTypeChanged() {
    localStorage.setItem("printType", this.printType.toString());
  }

  @Watch("printSum")
  printSumChanged() {
    localStorage.setItem("printSum", String(this.printSum));
  }

  @Watch("printDeducation")
  printDeducationChanged() {
    localStorage.setItem("printDeducation", String(this.printDeducation));
  }

  private updateData(searchCondition: SearchCondition) {
    this.postJsonCheck(
      window.base_url + "/api/office/care/userinvoice/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        only_not_printed: searchCondition.isDone,
        insurance_no: searchCondition.insuranceNo,
        insurance_name: searchCondition.insuranceName,
        ibow_id: searchCondition.userCode,
        furigana: searchCondition.userKana,
        insured_no: searchCondition.userInsNo,
        only_invoicer: this.onlyInvoicer
      },
      res => {
        this.tableItems = res.data.receipts;
        this.baseTable.refreshSelectItem();
        this.$router
          .replace(
            `/care/userinvoice?only=${searchCondition.isDone}&insurance_no=${searchCondition.insuranceNo}&insurance_name=${searchCondition.insuranceName}&ibow_id=${searchCondition.userCode}&furigana=${searchCondition.userKana}&insured_no=${searchCondition.userInsNo}`
          )
          .catch(err => err);
        this.$nextTick(() => {
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  private search(searchCondition: SearchCondition) {
    this.updateData(searchCondition);
  }

  private done(objectIds: ObjectId[]) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/care/userinvoice",
      {
        ids: objectIds.map(objectId => objectId.id),
        invoice_ymd: this.invoiceYMD,
        receipt_ymd: this.receiptYMD,
        print_type: this.printType,
        print_sum: this.printSum,
        print_deduction: this.printDeducation,
        print_no_invoice: this.printNoInvoice
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  private checked(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/care/userinvoice/checked",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "◯";
        });
      }
    );
  }

  private cancel(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/care/userinvoice/cancel",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "";
        });
      }
    );
  }

  private edit(item: ObjectId) {
    this.$router.push({
      path: "/care/edit/" + item.patient_id + "?tab=userinvoice"
    });
  }
}
